import React from "react";
import { Link } from "react-router-dom";
import { Construction } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Placeholder for screens still under construction.
 * Renders inside whichever shell the route uses.
 */
export function ComingSoon({ title, screenId, description, backTo = "/" }) {
  return (
    <div className="max-w-2xl mx-auto py-16 text-center">
      <div className="size-12 rounded-full bg-brand-50 text-brand-700 grid place-items-center mx-auto mb-5">
        <Construction className="size-5" />
      </div>
      <div className="eyebrow mb-2">{screenId} · In progress</div>
      <h2 className="text-h1 font-brand text-ink mb-2">{title}</h2>
      <p className="text-body text-ink-muted max-w-md mx-auto leading-relaxed">
        {description || "This screen is part of the prototype build but isn’t wired up yet. The shell, design system, and navigation work as you’d expect."}
      </p>
      <Link to={backTo} className="inline-block mt-6">
        <Button variant="outline">Back</Button>
      </Link>
    </div>
  );
}

export default ComingSoon;
